var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEniopro1White(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 978.31 199.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    className: "cls-1",
    d: "m190.55,0h-86.52c-4.7,0-8.52,3.82-8.52,8.52v81.68h7.75V8.52c0-.42.35-.77.77-.77h86.52c.42,0,.77.36.77.77v86.52c0,.42-.36.77-.77.77h-81.45s-13.55,0-13.55,0v.02c-.17-.01-.34-.02-.51-.02H8.52c-4.7,0-8.52,3.82-8.52,8.52v86.52c0,4.7,3.82,8.52,8.52,8.52h86.52c4.7,0,8.52-3.82,8.52-8.52v-81.68h-7.75v81.68c0,.42-.36.77-.77.77H8.52c-.42,0-.77-.35-.77-.77v-86.52c0-.42.35-.77.77-.77h95v-.02c.17.01.34.02.51.02h86.52c4.7,0,8.52-3.82,8.52-8.52V8.52c0-4.7-3.82-8.52-8.52-8.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    className: "cls-1",
    x: 134.42,
    y: 39.88,
    width: 25.59,
    height: 25.59,
    rx: 2.86,
    ry: 2.86
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    className: "cls-1",
    x: 38.8,
    y: 135.37,
    width: 25.59,
    height: 25.59,
    rx: 3.19,
    ry: 3.19
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    className: "cls-1",
    d: "m267.74,163.61V37.07h81.34v21.69h-57.48v30.19h52.42v21.69h-52.42v31.27h58.57v21.69h-82.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    className: "cls-1",
    d: "m367.88,163.61V37.07h45.37l25.13,110.27h3.25V37.07h23.5v126.53h-45.37l-25.13-110.26h-3.25v110.26h-23.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    className: "cls-1",
    d: "m488.99,163.61V37.07h23.86v126.53h-23.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    className: "cls-1",
    d: "m585.88,166.14c-15.91,0-28.56-4.37-37.96-13.1-9.4-8.74-14.1-21.24-14.1-37.51v-30.37c0-16.27,4.7-28.77,14.1-37.51,9.4-8.74,22.05-13.11,37.96-13.11s28.56,4.37,37.96,13.11c9.4,8.74,14.1,21.24,14.1,37.51v30.37c0,16.27-4.7,28.77-14.1,37.51-9.4,8.74-22.05,13.1-37.96,13.1Zm0-21.33c8.92,0,15.84-2.59,20.79-7.77,4.94-5.18,7.41-12.11,7.41-20.79v-31.81c0-8.68-2.47-15.61-7.41-20.79-4.94-5.18-11.87-7.77-20.79-7.77s-15.7,2.59-20.7,7.77c-5,5.18-7.5,12.11-7.5,20.79v31.81c0,8.68,2.5,15.61,7.5,20.79,5,5.18,11.9,7.77,20.7,7.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    className: "cls-1",
    d: "m662.52,163.61V37.07h46.82c7.47,0,14.19,1.42,20.15,4.25,5.97,2.83,10.69,6.9,14.19,12.2,3.49,5.3,5.24,11.75,5.24,19.34v2.17c0,7.59-1.78,14.07-5.33,19.43-3.56,5.36-8.31,9.43-14.28,12.2-5.96,2.77-12.62,4.16-19.97,4.16h-35.25v52.78h-11.57Zm11.57-63.27h33.98c9.04,0,16.18-2.23,21.42-6.69,5.24-4.46,7.86-10.72,7.86-18.8v-1.81c0-8.19-2.56-14.49-7.68-18.89-5.12-4.4-12.32-6.6-21.6-6.6h-33.98v52.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    className: "cls-1",
    d: "m770.98,163.61V37.07h49.53c7.83,0,14.73,1.33,20.7,3.98,5.97,2.65,10.67,6.48,14.1,11.48,3.43,5,5.15,11.06,5.15,18.17v1.81c0,8.56-2.05,15.27-6.15,20.16-4.1,4.88-8.92,8.11-14.46,9.67v2.17c4.22.12,7.77,1.45,10.67,3.98,2.89,2.53,4.34,6.57,4.34,12.11v43.02h-11.57v-41.76c0-3.86-1.06-6.81-3.16-8.86-2.11-2.05-5.27-3.07-9.49-3.07h-48.08v53.69h-11.57Zm11.57-64.17h36.88c9.4,0,16.66-2.2,21.78-6.6,5.12-4.4,7.68-10.69,7.68-18.89v-.9c0-8.19-2.5-14.49-7.5-18.89-5-4.4-12.32-6.6-21.96-6.6h-36.88v51.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    className: "cls-1",
    d: "m929.69,166.14c-14.82,0-26.63-4.37-35.43-13.1-8.8-8.74-13.2-21.54-13.2-38.41v-28.56c0-16.87,4.4-29.67,13.2-38.41,8.79-8.74,20.61-13.11,35.43-13.11s26.63,4.37,35.43,13.11c8.8,8.74,13.2,21.54,13.2,38.41v28.56c0,16.87-4.4,29.68-13.2,38.41-8.8,8.74-20.61,13.1-35.43,13.1Zm0-10.48c11.81,0,20.94-3.55,27.38-10.67,6.45-7.11,9.67-17.11,9.67-30.01v-29.28c0-12.89-3.23-22.9-9.67-30.01-6.45-7.11-15.58-10.67-27.38-10.67s-20.79,3.56-27.3,10.67c-6.51,7.11-9.76,17.11-9.76,30.01v29.28c0,12.9,3.25,22.9,9.76,30.01,6.51,7.11,15.61,10.67,27.3,10.67Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEniopro1White);
export default __webpack_public_path__ + "static/media/eniopro1_white.7373e19c9d54b912047d9ae39ab74341.svg";
export { ForwardRef as ReactComponent };